import {Action} from "redux"
import {State} from "./app";
import {ProcessFormAction, ProcessFormActionWrapper} from "./action";

export const reducer = (s: State, a: Action): State => {
	if(isProcessFormAction(a)) {
		return processFormReducer(s, a.action)
	}
	return s
}

const isProcessFormAction = (a: Action): a is ProcessFormActionWrapper => a.type == 'process form action'

const processFormReducer = (s: State, a: ProcessFormAction): State =>
	validate(processFormReducer_(s, a))

export const validate = (s: State): State => {
	if(!s.multiPricingOption && !s.selectedPricingOptions.length) {
		return validate({...s, selectedPricingOptions: [s.pricingOptions[0].id]})
	}

	if(!s.multiStatus && !s.selectedStatuses.length) {
		return validate({...s, selectedStatuses: [s.statuses[0].id]})
	}

	return s
}

const processFormReducer_ = (s: State, a: ProcessFormAction): State => {
	switch (a.type) {
		case "set process id":
			return {...s, processId: a.id}
		case "set name":
			return {...s, name: a.name}
		case "set multi pricing option":
			return {...s, multiPricingOption: a.multiPricingOption}
		case "set pricing options":
			return {...s, selectedPricingOptions: a.pricingOptions}
		case "set multi status":
			return {...s, multiStatus: a.multiStatus}
		case "set statuses":
			return {...s, selectedStatuses: a.statuses}
		case "set process days":
			return {...s, processDays: a.processDays}
		case "set process direction":
			return {...s, processDirection: a.processDirection}
		case "set collation type":
			return {...s, collationType: a.collationType}
		case "set send emails":
			return {...s, sendEmails: a.sendEmails}
		case "set enabled":
			return {...s, enabled: a.enabled}
		case "set submitting":
			return {...s, submitting: a.submitting}
		case "set payment type":
			return {
				...s,
				selectedPaymentType: a.paymentType,
				collationType: a.paymentType == 'all' ? s.collationType : 'none'
			}
	}
}



// WEBPACK FOOTER //
// ./src/membership3/auto-renewal/process-form/reducer.ts